import { Check } from "lucide-react";
import { RECIPE_CARDS, RECIPE_HEADING } from "@/data/content";

export const RecipeGrid = () => {
  return (
    <section data-testid="recipe-section" className="bg-[#fafafa] py-16 md:py-22 border-y border-[#f1f1f1]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h3 className="text-center font-nunito text-2xl sm:text-3xl font-extrabold text-[#383838] heading-redul-center">
          {RECIPE_HEADING}
        </h3>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {RECIPE_CARDS.map((card, idx) => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                data-testid={`recipe-card-${idx + 1}`}
                className="rounded-[12px] bg-white border border-[#ececec] p-6 shadow-[0_6px_18px_rgba(2,2,2,0.04)] hover:-translate-y-1 hover:shadow-[0_14px_40px_rgba(2,2,2,0.1)] transition-transform duration-200"
              >
                <div className="h-11 w-11 rounded-[10px] bg-[#ee2e24]/[0.08] flex items-center justify-center">
                  <Icon size={20} strokeWidth={1.75} className="text-[#ee2e24]" />
                </div>
                <h3 className="mt-4 font-nunito text-base font-extrabold text-[#383838]">{card.title}</h3>
                <ul className="mt-3.5 space-y-2">
                  {card.items.map((item) => (
                    <li key={item} className="flex items-start gap-2 text-[13px] text-[#6e6e6e] leading-snug">
                      <Check size={14} strokeWidth={2.25} className="text-[#ee2e24] mt-0.5 shrink-0" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
